import type { Payment } from 'paintscout'

/**
 * Sorts payments by date, then slots child payments (refunds, processing/failed
 * from a request) directly after their parent. Orphaned children are appended at the end.
 */
export function orderPaymentsWithChildren(payments: Payment[]): Payment[] {
  const sorted = [...payments].sort((a, b) => (a.date ?? 0) - (b.date ?? 0))
  const refunds = sorted.filter((p) => !!p.forPaymentId)
  const processingFromRequest = sorted.filter(
    (p) => !!p.paymentRequestId && (p.status === 'processing' || p.status === 'failed')
  )
  const base = sorted.filter(
    (p) => !p.forPaymentId && !(p.paymentRequestId && (p.status === 'processing' || p.status === 'failed'))
  )

  const result: Payment[] = []
  for (const payment of base) {
    result.push(payment)
    result.push(...processingFromRequest.filter((p) => p.paymentRequestId === payment.id))
    result.push(...refunds.filter((r) => r.forPaymentId === payment.id))
  }

  // safety net: append any orphaned children whose parent wasn't found
  const placed = new Set(result.map((p) => p.id))
  processingFromRequest.filter((p) => !placed.has(p.id)).forEach((p) => result.push(p))
  refunds.filter((r) => !placed.has(r.id)).forEach((r) => result.push(r))

  return result
}
